import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import threadInfoFragment from '../../fragments/thread/threadInfo';

export const publishThreadMutation = gql`
  mutation publishThread($thread: ThreadInput!) {
    publishThread(thread: $thread) {
      ...threadInfo
    }
  }
  ${threadInfoFragment}
`;

const publishThreadOptions = {
  props: ({ mutate }) => ({
    publishThread: thread =>
      mutate({
        variables: {
          thread,
        },
      }),
  }),
};

export default graphql(publishThreadMutation, publishThreadOptions);
